var _g, _g2, _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_196_14466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47955e-05 20V1C2.47955e-05 0.447715 0.447741 0 1.00003 0H10.9121C11.1728 0 11.4232 0.101781 11.6099 0.283662L15.519 4.09134C15.7057 4.27322 15.9561 4.375 16.2167 4.375H27.7458C28.2981 4.375 28.7458 4.82272 28.7458 5.375V20C28.7458 20.5523 28.2981 21 27.7458 21H1.00002C0.447741 21 2.47955e-05 20.5523 2.47955e-05 20Z",
    fill: "#463527"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_196_14466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7458 20V1C28.7458 0.447715 28.298 0 27.7458 0H17.8337C17.573 0 17.3226 0.101781 17.1359 0.283662L13.2268 4.09134C13.0401 4.27322 12.7897 4.375 12.5291 4.375H1C0.447715 4.375 0 4.82272 0 5.375V20C0 20.5523 0.447715 21 0.999999 21H27.7458C28.298 21 28.7458 20.5523 28.7458 20Z",
    fill: "url(#paint0_linear_196_14466)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 8.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "#F95111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 15.75L25 19.25L21 15.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 8.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_196_14466",
    x: 0,
    y: 0,
    width: 28.7458,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_196_14466"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_196_14466",
    x: 0,
    y: -1,
    width: 28.7458,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_196_14466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_196_14466",
    result: "effect2_innerShadow_196_14466"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_14466",
    x1: 12.9356,
    y1: 4.375,
    x2: 29.3753,
    y2: 21.4322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB947D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF8D6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOpen);
export default __webpack_public_path__ + "static/media/document_open.7fa69025.svg";
export { ForwardRef as ReactComponent };